<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;">
					<h4 style="font-weight: bold; margin-bottom: 10px">{{$store.state.lang.text.deposit[$store.state.lang.language]}}</h4>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-60 md-small-size-50 md-medium-size-50 md-size-50">
				<div class="verification__box">
					<div class="attach__wrap">
						 <select v-model="select" @change="changeMethod()">
							  <option value="">{{$store.state.lang.text.choose_deposit_method[$store.state.lang.language]}}</option>
							  <option v-for="method in method_deposit" :value="method.id">{{method.type}}</option>
						 </select>
					</div>
			  </div>
			</div>
			<div class="md-layout-item md-xsmall-size-40 md-small-size-50 md-medium-size-50 md-size-50">
				<div class="verification__box">
					<div class="attach__wrap">
						 <select v-model="currency" @change="changeCurrency()">
							  <option value="usd">USD ($)</option>
							  <option value="khr">KHR (៛)</option>
						 </select>
					</div>
			  </div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
				<div class="deposit-list-menu"><span>{{$store.state.lang.text.bank_name[$store.state.lang.language]}}: {{account.name}}</span></div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
				<div class="deposit-list-menu"><span>{{$store.state.lang.text.bank_number[$store.state.lang.language]}}: {{account.number}}</span></div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<input v-if="currency == 'usd'" type="number" v-model="deposit.amount" :placeholder="$store.state.lang.text.deposit_amount[$store.state.lang.language]">
							<input v-if="currency == 'khr'" type="number" v-model="deposit.amount" :placeholder="$store.state.lang.text.deposit_amount_khr[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div style="padding: 10px 0 0">
					<table>
						<tr>
							<td>ដាក់ប្រាក់ចំនួន</td>
							<td style="width: 50px;text-align: center;">:</td>
							<td>
								<b><span v-if="String(deposit.amount).length >0">{{config.moneylify(deposit.amount, currency)}}</span>
									<span v-else>-</span></b>
							</td>
						</tr>
						<tr>
							<td>ទឹកប្រាក់ទទួលបាន</td>
							<td style="width: 50px;text-align: center;">:</td>
							<td>
								<span v-if="String(deposit.amount).length >0">
									<span v-if="currency == 'khr'"><b>{{config.moneylify(deposit.amount / 4100)}}</b> (1USD = 4100KHR)</span>
									<span v-else><b>{{config.moneylify(deposit.amount)}}</b></span>
								</span>
								<span v-else><b>-</b></span>
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="deposit-list-menu" style="margin-top: 15px; display: flex; flex-direction: column; justify-content: center;align-items: center;">
					<a class="cmn--btn" @click="$refs.file.click()" style="margin-top: 5px"><span>{{$store.state.lang.text.choose_transaction_image[$store.state.lang.language]}}</span></a>
						<img v-if="preview.length > 0" :src="this.preview" style="margin-top: 8px;width:80%"/>
						<loading v-if="uploading"/>
						<input type="file" ref="file" accept="image/*" @change="handleFile($event)" style="display: none" />
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="form__tabs__wrap">
					<form>
						<div class="create__btn"><a class="cmn--btn" @click="requestDeposit()" style="margin-top: 5px"><span>{{$store.state.lang.text.deposit[$store.state.lang.language]}}</span></a></div>
					</form>
				</div>
			</div>
		</div>
		<Confirm :active.sync="confirmActive" :title.sync="$store.state.lang.text.confirm_deposit[$store.state.lang.language]" @onCancel="cancelDeposit" @onConfirm="requestDeposit"/>
	</div>
</template>

<script>

	import Confirm from '@/components/Confirm';

	export default {
		components: {
			Confirm
		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.getPayment();
			this.getBalance();
		},
		data() {
			return {
				loaded: false,
				uploading: false,
				preview: "",
				currentBalance: 0,
				select: "",
				currency: "usd",
				deposit: {
					payment_id: "",
					payment_type: "",
					amount: "",
					transaction_url_token: ""
				},
				account: {
					name: "",
					number: ""
				},
				confirmActive: false,
				method_deposit: []
			}
		},
		methods: {
			getBalance() {
				this.$http.get(this.config.api + "/user/authed/user/get_balance").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.currentBalance = res.body.data.balance;
					}
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/user/authed/payment/get_data").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.method_deposit = res.body.data.method_deposit;
					}
				})
			},
			handleFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.file.files[0]);
				this.uploading = true;
				this.$http.post(this.config.api + "/user/authed/payment/upload_transaction", formData).then(res => {
						this.uploading = false;
						if (res.body.status == 'success') {
							this.deposit.transaction_url_token = res.body.data.token;
							let data = String(this.deposit.transaction_url_token).split(".")[1];
							let obj = JSON.parse(atob(data));
							this.preview = this.config.getTransactionUrl(obj.image_id);
						}
					})

			},
			requestDeposit() {

				if(this.deposit.payment_type.length > 0 && String(this.deposit.amount).length >0 && parseFloat(this.deposit.amount) == this.deposit.amount && this.deposit.transaction_url_token.length > 0) {

					if(this.confirmActive) {
						this.confirmActive = false;
						this.$store.state.authentication.loading = true;

						let transaction_url_token = this.deposit.transaction_url_token;
						let amount = this.deposit.amount;
						this.deposit.transaction_url_token = "";
						this.deposit.amount = "";

						this.$http.post(this.config.api + "/user/authed/payment/deposit", {
							payment_id: this.deposit.payment_id,
							payment_type: this.deposit.payment_type,
							amount: amount,
							currency: this.currency,
							transaction_url_token: transaction_url_token
						}).then(res => {
							this.$store.state.authentication.loading = false;
							if (res.body.status == 'success') {
								this.$router.push("/account/transaction");
								this.$notification.notify(this.$store.state.lang.text.deposit_success[this.$store.state.lang.language]);
							}
						})
					} else {
						this.confirmActive = true;
					}
				} else {
					this.$notification.notify(this.$store.state.lang.text.pleaseFill[this.$store.state.lang.language]);
				}
			},
			changeCurrency() {
				this.changeMethod();
			},
			changeMethod() {
				if(this.select.length == "") {
					this.account.name = "";
					this.account.number = "";
					this.deposit.payment_type = "";
					this.deposit.payment_id = "";
				} else {
					for(let i = 0; i<this.method_deposit.length; i++) {
						if(this.method_deposit[i].id == this.select) {
							this.deposit.payment_type = this.method_deposit[i].type;
							this.deposit.payment_id = this.method_deposit[i].id;
							if(this.currency == 'usd') {
								this.account.name = this.method_deposit[i].account_name_usd;
								this.account.number = this.method_deposit[i].account_usd;
							} else if (this.currency == 'khr') {
								this.account.name = this.method_deposit[i].account_name_khr;
								this.account.number = this.method_deposit[i].account_khr;
							}
						}
					}
				}

			},
			cancelDeposit() {
				this.confirmActive = false;
			}

		}

	}
</script>
<style>
	.deposit-list-menu {
		cursor:pointer; border-radius: 15px;padding: 14px; margin-bottom: 15px;background-color: var(--secondary-color);
	}
	.deposit-list-menu-left {
		min-width: calc(30% - 15px) !important;
		max-width: calc(30% - 15px) !important;
		margin-right: 15px !important;
	}
	@media (min-width: 945px) and (max-width: 1264px) {
		.deposit-list-menu-left {
			min-width: calc(40% - 15px) !important;
			max-width: calc(40% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (min-width: 601px) and (max-width: 944px) {
		.deposit-list-menu-left {
			min-width: calc(50% - 15px) !important;
			max-width: calc(50% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (max-width: 600px) {
		.deposit-list-menu-left {
			min-width: 100% !important;
			max-width: 100% !important;
			margin-right: 0px !important;
		}
	}

</style>



// WEBPACK FOOTER //
// src/pages/Account/Deposit.vue